import { render } from "./goodsType.vue?vue&type=template&id=569c9b0b"
import script from "./goodsType.vue?vue&type=script&lang=js"
export * from "./goodsType.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__